import React from "react";
import { connect } from "react-redux";
import { displayInvalidDialog } from "../../../../actions";
import { bindActionCreators } from "redux";
import ReviewLinkButton from "./ReviewLinkButton";
import Dialog from "../../../Dialog";
import "./ReviewLink.css";

class ReviewLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInvalidDialog: false,
      showLargePlateDialog: false,
      showOutOfStockDialog: false
    };
  }

  componentDidUpdate(prevProps) {
    // Show dialog when conditions change
    if (
      prevProps.design.numInvalidElements === 0 &&
      this.props.design.numInvalidElements > 0
    ) {
      this.setState({ showInvalidDialog: true });
    }
    if (
      prevProps.design.largePlate === false &&
      this.props.design.largePlate === true
    ) {
      this.setState({ showLargePlateDialog: true });
    }
    if (
      prevProps.areAnyColorsOutOfStock === false &&
      this.props.areAnyColorsOutOfStock === true
    ) {
      this.setState({ showOutOfStockDialog: true });
    }
  }

  hideInvalidDialog = () => {
    this.setState({ showInvalidDialog: false });
  };

  hideLargePlateDialog = () => {
    this.setState({ showLargePlateDialog: false });
  };

  hideOutOfStockDialog = () => {
    this.setState({ showOutOfStockDialog: false });
  };

  render() {
    const dialog = {
      title: "Design Notice",
      message:
        "Your current design is outside the printable area. Please adjust it before continuing.",
      topPosition: 0,
      leftPosition: "auto",
      origin: "topright",
      type: ""
    };

    const dialog2 = {
      title: "Design Notice",
      message:
        "Your design exceeds our maximum plate size. There will be an additional $10 Excess Plate Charge for this design. You may avoid this by making your design smaller or moving the elements closer together.",
      topPosition: 0,
      leftPosition: "auto",
      origin: "topright",
      type: ""
    };

    const outOfStockDialog = {
      title: "Design Notice",
      message:
        "Your design is currently using an out of stock color. You may avoid this by choosing a different color.",
      topPosition: 0,
      leftPosition: "auto",
      origin: "topright",
      type: ""
    };

    return (
      <div className="step-buttons">
        <ReviewLinkButton
          routeId={this.props.routeId}
          numInvalidElements={this.props.design.numInvalidElements}
          location={this.props.location}
          areAnyColorsOutOfStock={this.props.areAnyColorsOutOfStock}
        />
        {this.props.design.largePlate === true &&
          this.state.showLargePlateDialog && (
            <div className="step-buttons__dialog">
              <Dialog
                dialog={dialog2}
                onHideDialog={this.hideLargePlateDialog}
              />
            </div>
          )}
        {this.props.design.numInvalidElements > 0 &&
          this.state.showInvalidDialog && (
            <div className="step-buttons__dialog">
              <Dialog dialog={dialog} onHideDialog={this.hideInvalidDialog} />
            </div>
          )}
        {this.props.areAnyColorsOutOfStock === true &&
          this.state.showOutOfStockDialog && (
            <div className="step-buttons__dialog">
              <Dialog
                dialog={outOfStockDialog}
                onHideDialog={this.hideOutOfStockDialog}
              />
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selecToolCollection to reducers
  return bindActionCreators(
    {
      displayInvalidDialog
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewLink);
